const TutorPupilWavingDecoration = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="246"
            height="456"
            fill="none"
            viewBox="0 0 246 456"
        >
            <path
                fill="#1E88E5"
                d="M12.98 209.419c41.707 39.92 69.66 53.017 126.529 48.939l6.716-13.286c-55.464 1.658-84.171-8.031-122.283-46.382-3.724-3.748-10.072-2.843-12.456 1.872-1.498 2.963-.905 6.561 1.494 8.857z"
            ></path>
            <path
                fill="#1E88E5"
                d="M199.916 73.756l45.775 44.094v248.5L75.785 202.577c-36.031-34.73-36.56-92.263-1.173-127.65 34.47-34.47 90.195-34.991 125.304-1.17z"
            ></path>
            <path
                fill="#FFA726"
                d="M221.666 451.374l24.023-27.026v-136.5l-37.38-33.448c-28.66-25.646-72.379-24.38-99.508 2.882-29.357 29.5-27.826 77.628 3.346 105.203l101.059 89.397a6 6 0 008.46-.508z"
            ></path>
            <path
                fill="#FFA726"
                d="M209.801 223.426c16.349 12.963 24.967 23.232 35.888 41.924v36.5c-8.128-31.831-15.734-49.515-42.606-69.063-2.636-1.918-3.286-5.619-1.352-8.244 1.902-2.581 5.558-3.109 8.07-1.117z"
            ></path>
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="8.504"
                d="M127.999 142.127c-8.347-5.975-12.715-10.239-19.9-19.617M141.237 129.239c-8.348-5.975-12.715-10.239-19.9-19.617"
            ></path>
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="6.027"
                d="M115.616 185.632c-.783-9.301-.384-14.152 4.635-21.671M161.516 122.481c7.533-5.511 11.883-7.696 20.915-7.326"
            ></path>
            <mask id="path-9-inside-1_96_3392" fill="#fff">
                <path d="M170.871 119.2c-11.14 27.417-21.374 41.662-52.151 54.137-1.778.72-2.263 3.04-.886 4.375l31.898 30.905c2.257 2.188 5.558 2.966 8.523 1.92 30.21-10.658 41.018-24.406 50.889-52.608 1.077-3.077.226-6.499-2.115-8.767l-31.875-30.884c-1.343-1.301-3.579-.809-4.283.922z"></path>
            </mask>
            <path
                fill="#000"
                d="M170.871 119.2c-11.14 27.417-21.374 41.662-52.151 54.137-1.778.72-2.263 3.04-.886 4.375l31.898 30.905c2.257 2.188 5.558 2.966 8.523 1.92 30.21-10.658 41.018-24.406 50.889-52.608 1.077-3.077.226-6.499-2.115-8.767l-31.875-30.884c-1.343-1.301-3.579-.809-4.283.922z"
            ></path>
            <path
                fill="#000"
                d="M118.72 173.337l2.264 5.585-2.264-5.585zm52.151-54.137l5.584 2.269-5.584-2.269zm-12.616 91.337l2.005 5.684-2.005-5.684zm50.889-52.608l-5.689-1.991 5.689 1.991zm-88.16 20.993c15.927-6.455 27.04-13.574 35.628-22.988 8.528-9.348 14.194-20.562 19.843-34.465l-11.168-4.537c-5.491 13.514-10.513 23.131-17.58 30.878-7.008 7.682-16.401 13.922-31.251 19.941l4.528 11.171zm-7.344 3.118l31.898 30.906 8.387-8.657-31.897-30.906-8.388 8.657zm46.62 34.181c15.66-5.525 26.884-12.06 35.48-21.305 8.547-9.193 14.052-20.597 19.092-34.996l-11.377-3.982c-4.831 13.803-9.666 23.373-16.543 30.77-6.828 7.344-16.112 13.012-30.663 18.146l4.011 11.367zm50.962-71.388l-31.874-30.883-8.388 8.657 31.875 30.883 8.387-8.657zm3.61 15.087c1.874-5.353.375-11.226-3.61-15.087l-8.387 8.657c.698.677.901 1.646.62 2.448l11.377 3.982zm-69.294 53.026c3.837 3.717 9.52 5.11 14.722 3.275l-4.011-11.367c-.727.256-1.645.092-2.324-.565l-8.387 8.657zm30.917-91.477c-.873 2.148-3.709 2.868-5.495 1.138l8.388-8.657c-4.471-4.332-11.781-2.63-14.061 2.982l11.168 4.537zm-59.999 46.282c-5.682 2.303-7.424 9.824-2.816 14.289l8.388-8.657c1.853 1.795 1.082 4.677-1.044 5.539l-4.528-11.171z"
                mask="url(#path-9-inside-1_96_3392)"
            ></path>
            <path
                stroke="#000"
                strokeWidth="6.806"
                d="M217.075 85.247L195.7 64.54c-36.793-35.645-95.516-34.713-131.16 2.08v0c-35.645 36.794-34.713 95.517 2.08 131.161l21.376 20.708"
            ></path>
            <path
                fill="#000"
                d="M56.677 216.002a6.806 6.806 0 01-.153-9.624l11.367-11.733 41.064 39.782-11.366 11.733a6.806 6.806 0 01-9.625.152l-31.287-30.31zM240.762 81.198a6.806 6.806 0 01.153 9.624l-11.366 11.733c-14.838-14.565-25.089-24.706-41.86-38.705l12.366-12.653a6.807 6.807 0 019.604-.132l31.103 30.133z"
            ></path>
            <path
                stroke="#000"
                strokeWidth="4.084"
                d="M92.245 225.872c23.566-7.386 28.216-7.571 42.456-24.26m-10.526 4.018l7.103-7.333 7.333 7.104-7.119 6.37-7.317-6.141z"
            ></path>
            <path
                fill="#FFA726"
                d="M72.36 374.818c32.236 28.483 53.436 37.405 95.655 32.681l4.606-10.091c-41.245 2.88-62.905-3.481-92.418-30.904-2.884-2.679-7.584-1.818-9.219 1.764a5.622 5.622 0 001.376 6.55z"
            ></path>
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="8.257"
                d="M161.549 321.042c-8.346-5.449-12.759-9.404-20.118-18.202M173.854 307.991c-8.345-5.449-12.759-9.404-20.117-18.201"
            ></path>
            <path
                fill="#000"
                d="M165.136 360.701c-7.036-6.256-1.969-18.463 7.116-20.934 13.568-3.691 20.113-12.262 22.356-26.208 1.688-10.488 14.282-16.923 22.221-9.864 7.24 6.437 10.968 16.256 8.254 25.556-5.212 17.86-14.023 28.296-32.461 36.564-9.233 4.14-19.924 1.61-27.486-5.114z"
            ></path>
            <path
                stroke="#000"
                strokeWidth="5.217"
                d="M212.67 254.316l-6.028-5.281c-29.573-25.909-74.268-24.08-101.625 4.159v0c-28.356 29.271-27.615 75.987 1.655 104.343l10.114 9.798"
            ></path>
            <path
                fill="#000"
                d="M91.736 364.139a5.217 5.217 0 01-.117-7.377l8.711-8.992 31.472 30.489-8.711 8.993a5.218 5.218 0 01-7.377.117l-23.978-23.23zM240.875 259.603a5.217 5.217 0 01.347 7.369l-8.427 9.259-32.258-29.357 8.427-9.259a5.216 5.216 0 017.369-.347l24.542 22.335z"
            ></path>
            <path
                stroke="#000"
                strokeWidth="3.13"
                d="M121.295 371.703c18.06-5.66 21.624-5.802 32.538-18.592m-8.067 3.079l5.444-5.62 5.62 5.444-5.456 4.883-5.608-4.707z"
            ></path>
        </svg>
    );
};

export default TutorPupilWavingDecoration;
